export const CHANGE_DARK_MODE = 'CHANGE_DARK_MODE'

export const ADD_TASK_TO_LIST = 'ADD_TASK_TO_LIST'
export const DELETE_TASK_TO_LIST = 'DELETE_TASK_TO_LIST'
export const REORDER_TASK_LIST = 'REORDER_TASK_LIST'
export const CHANGE_TASK_STATE = 'CHANGE_TASK_STATE'
export const DELETE_COMPLETED_TASKS = 'DELETE_COMPLETED_TASKS'
export const GET_ITEM_TO_FILTER = 'GET_ITEM_TO_FILTER'
